<template>
  <div
    class="slides"
    :style="{'overflow-y': (dataMsg !== 'bg' || canScroll)?'scroll':'hidden'}"
    ref="slidesDOM"
  >
    <Template
      :slideState="slideState"
      :dataMsg="dataMsg"
      v-show="dataMsg === 'template'"
      ref="template"
    />
    <Scenes :slideState="slideState" :dataMsg="dataMsg" v-show="dataMsg === 'scenes'" ref="scenes" />
    <Bg
      :slideState="slideState"
      :dataMsg="dataMsg"
      v-show="dataMsg === 'bg'"
      ref="bg"
      @switchSettingPane="switchBgSettingPane"
    />
    <TextBox :slideState="slideState" :dataMsg="dataMsg" v-show="dataMsg === 'text'" />
    <Characters :slideState="slideState" :dataMsg="dataMsg" v-show="dataMsg === 'characters'" />
    <Props :slideState="slideState" :dataMsg="dataMsg" v-show="dataMsg === 'props'" />
    <Gif :slideState="slideState" :dataMsg="dataMsg" v-show="dataMsg === 'gif'" />
    <Shapes :slideState="slideState" :dataMsg="dataMsg" v-show="dataMsg === 'shapes'" />
    <Sound :slideState="slideState" :dataMsg="dataMsg" v-show="dataMsg === 'sound'" />
    <Personal :slideState="slideState" :dataMsg="dataMsg" v-show="dataMsg === 'personal'" />
    <Team :slideState="slideState" :dataMsg="dataMsg" v-show="dataMsg === 'team'" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Template from "./slide/template.vue"; // 模板
import Scenes from "./slide/scenes.vue"; // 场景
import Bg from "./slide/bg.vue"; // 背景
import TextBox from "./slide/text.vue"; // 文字
import Characters from "./slide/characters.vue"; // 角色
import Props from "./slide/props.vue"; // 道具
import Gif from "./slide/gif.vue"; // gif
import Shapes from "./slide/shapes.vue"; // 形状
import Sound from "./slide/sound.vue"; // 声音
import Personal from "./slide/personal.vue"; // 个人素材
import Team from "./slide/team.vue"; // 父子账号

const boxTypes = [
  "null",
  "template",
  "scenes",
  "bg",
  "text",
  "characters",
  "props",
  "sound",
  "personal",
  "team"
];
let scrollMarks = {};
boxTypes.forEach(v => {
  scrollMarks[v] = {};
});

export default {
  data() {
    return {
      dataMsg: "scenes",
      prevScrollTop: 0,
      canScroll: true
    };
  },
  computed: {
    ...mapGetters(["TopNav_Size", "RightNavComponents_Size"]),
    slideHeight() {
      const { hTop, hSearch, hOperation, hHr } = this.RightNavComponents_Size;
      return -hTop - hSearch - hOperation - hHr - 10;
    },
    slideTop() {
      const { hTop, hSearch, hOperation, hHr } = this.RightNavComponents_Size;
      return hTop + hSearch + hOperation + hHr + 10;
    }
  },
  watch: {
    dataMsg(val, prevBoxType) {
      // this.handleComponentsHeights(val);

      let prevMark = scrollMarks[prevBoxType];
      prevMark.value = this.$refs.slidesDOM.scrollTop;

      let mark = scrollMarks[val];
      if (!mark) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.slidesDOM.scrollTop = mark.value;
      });
    }
  },
  props: ["slideState"],
  mounted() {
    this.$bus.on("rightSlideBox_vue", data => {
      this.dataMsg = data.type;

      if (data.name) {
        this.$bus.emit("rightSlideBoxAction_vue", {
          type: data.type,
          name: data.name,
          judge: data.action || true
        });
      }
    });
    this.$bus.on("rightSlideBoxScrollTop_vue", data => {
      if (!scrollMarks[data.type]) {
        scrollMarks[data.type] = {};
      }
      scrollMarks[data.type].value = data.scrollTop;

      this.$refs.slidesDOM.scrollTop = data.scrollTop;
    });
    this.$refs.slidesDOM.addEventListener("scroll", () => {
      let el = this.$refs.slidesDOM;
      // let contentGoesDir = el.scrollTop > this.prevScrollTop
      //   ? 'up'
      //   : 'down';
      // this.$bus.emit('rightNav.contentGoes', contentGoesDir);
      this.prevScrollTop = el.scrollTop;
      this.$bus.emit("rightSlideBoxBroadcast_vue", {
        type: "rightSlide",
        scrollTop: el.scrollTop,
        el: el
      });
      this.handleBottomBtn();
      this.handleMoreBtnPosition(null, ".categoryPrompt");
    });

    $(window)
      .on("resize", () => {
        this.handleBottomBtn();
        this.handleMoreBtnPosition();
      })
      .on("scroll", () => {
        this.handleMoreBtnPosition();
      });

    this.$bus.on("rightNav.sectionClicked", () => {
      $(this.$el)
        .find(".bottom-more")
        .css({
          position: "static",
          bottom: 0,
          zIndex: 0
        });
      this.$nextTick(() => {
        this.handleBottomBtn();
      });
    });
  },
  methods: {
    handleBottomBtn() {
      let container = $(this.$el);
      let box = container.find(".data-body.operation:visible");
      if (!box[0]) {
        return;
      }
      let rect = box[0].getBoundingClientRect();
      let btn = box.find(".bottom-more");
      if (rect.bottom + 50 > window.innerHeight) {
        btn.css({
          position: "fixed",
          bottom: "29px",
          // left: rect.left + 'px',
          // 遮住星星
          zIndex: 101
        });
      } else {
        btn.css({
          position: "static",
          bottom: 0,
          zIndex: 0
        });
      }

      let scenesbtn = box.find(".scenes-more");
      if (rect.bottom + 50 > window.innerHeight) {
        scenesbtn.css({
          position: "fixed",
          bottom: "29px",
          // left: rect.left + 'px',
          // 遮住星星
          zIndex: 101
        });
      } else {
        scenesbtn.css({
          position: "static",
          bottom: 0,
          zIndex: 0
        });
      }
    },
    handleComponentsHeights(typeName) {
      let shouldBeNoHeight = typeName === "characters" || typeName === "text";
      this.$store.commit("save_RightNavComponents", {
        hHr: shouldBeNoHeight ? 0 : 2
      });
    },
    handleMoreBtnPosition(inputLeft, selector) {
      if (this.dataMsg == "scenes") {
        $(this.$el)
          .find(selector || ".scenes-more ,.categoryPrompt")
          .css({
            left: 372 + "px"
          });
        return;
      }

      let left =
        inputLeft == null ? this.$el.getBoundingClientRect().left : inputLeft;
      $(this.$el)
        .find(
          selector ||
            ".more-template, .more-sound, .more-props, .bottom-more,.categoryPrompt"
        )
        .css({
          left: left + "px"
        });
    },
    switchBgSettingPane(type) {
      if (type == "color") {
        this.canScroll = false;
      } else {
        this.canScroll = true;
      }
    }
  },
  components: {
    Scenes,
    Bg,
    TextBox,
    Characters,
    Props,
    Shapes,
    Sound,
    Personal,
    Team,
    Gif,
    Template
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.slides {
  //position: absolute;
  margin-left: 10px;
  z-index: 5;
  height: 0;
  flex-grow: 1;
  width: 110%;
  //overflow-y: scroll;
  overflow-x: hidden;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide.vue